<!--
* UIID: UI-DLB-MD-110
* UI Name: Mapping Definition Version History
* Modify Date: 2020/08/10
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="popup-history"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.mappingDefinition.mappingDefinitionVersionHistory.pageHeader')}}</v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">      
      <v-card-text class="ml-4 pa-0 popup-title">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <span class="title-file-name--text">{{this.versionList.MPD_FILE_NAME}}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup top buttons-->
      <v-card-text class="top-btn-display-m">
        <v-row class="ma-0 mb-2">
          <v-col cols="12" class="pa-0">
            <v-btn class="mr-4 btn btn-popup-search float-right" color="primary" tile dark @click="openCheckIn">
              {{$t('btn.mappingDefiniton.checkIn')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup top buttons-->

      <!-- [S]  Popup body-->
      <v-card-text class="content-version-section">
        <v-row class="content-covering-m pt-0">
          <v-col cols="12" class="pa-0">
            <v-row class="version-history-table ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :hide-default-footer="true"
                  :items="historyList"
                  :fixed-header="true"
                  class="analyzed-layout-table"
                  disable-pagination
                  disable-sort
                  height="95"
                >
                  <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th
                          class="text-center text-version"
                          style="width:51px"
                        >{{$t('tbl.mappingDefinition.versionHistory.ver')}}</th>
                        <th
                          class="text-center text-version"
                          colspan="2"
                          style="width:117px"
                        >{{$t('tbl.mappingDefinition.versionHistory.select')}}</th>
                        <th
                          class="text-center text-version"
                          style="width:133px"
                        >{{$t('tbl.mappingDefinition.versionHistory.date')}}</th>
                        <th
                          class="text-center text-version"
                        >{{$t('tbl.mappingDefinition.versionHistory.user')}}</th>
                        <th
                          class="text-center text-version"
                        >{{$t('tbl.mappingDefinition.versionHistory.changeHistory')}}</th>
                        <th
                          class="text-center text-version"
                          style="width:60px"
                        >{{$t('tbl.mappingDefinition.versionHistory.delete')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center text-bold">{{ item.MPD_VERSION }}</td>
                        <td
                          v-if="item.CURVER_YN === 'Y'"
                          class="text-left align-radio"
                          style="width:29px"
                        >
                          <input
                            type="radio"
                            v-model="item.CURVER_YN"
                            :value="item.CURVER_YN"
                            name="matched-map"
                            @click="selectVersion(item)"
                          />
                        </td>
                        <td
                          v-if="item.CURVER_YN === 'N'"
                          class="text-left align-radio"
                          style="width:29px"
                        >
                          <input type="radio" name="matched-map" @click="selectVersion(item)" />
                        </td>
                        <td class="text-left" style="width:87px">
                          <a
                            @click="openCheckOut(item)"
                          >{{$t('tbl.mappingDefinition.versionHistory.checkOut')}}</a>
                        </td>
                        <td class="text-left">{{ item.CRE_DT }}</td>
                        <td class="text-left text-bold">{{ item.CRE_USR }}</td>
                        <td class="text-left">{{ item.CHKIN_COMT }}</td>
                        <td class="text-center">
                          <v-btn small text icon @click="deleteItem(item)">
                            <icon-svg iconName="delete" />
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{$t('btn.common.reset')}}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <!-- [S]  Popup buttons-->
      <v-card-text class="footer-display-popup">
        <v-divider class="ml-0 mr-0 mt-2 divder-popup" inset></v-divider>
        <v-row class="ma-0 mt-2">
          <v-col cols="12" class="pa-0">
            <div class="btn-form-control text-right mr-4">
              <v-btn class="btn btn-delete btn-popup" tile @click="removeDialog">
                {{$t('btn.common.close')}}
              </v-btn>
              <v-btn class="btn btn-search btn-popup" color="primary" tile @click="saveVersionHistory">
                {{$t('btn.common.save')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup buttons-->
    </v-card>
    <dialogWindow
      ref="warningDialog"
      size="max"
      :detail="$t('msg.mappingDefinition.versionHistory.warningCheckIn')"
      color="warning"
    ></dialogWindow>
    <dialogWindow
      ref="checkOutDialog"
      size="max"
      :detail="$t('msg.mappingDefinition.versionHistory.clickLinkCheckOut')"
      color="confirmation"
      show-cancel="true"
      @select-close="onClickCancel"
      @select-ok="onClickOkay"
    ></dialogWindow>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      :detail="$t('msg.common.infoConfirm.detail',['delete the selected items'])"
      color="confirmation"
      show-cancel="true"
      @select-ok="onClickDelete"
    ></dialogWindow>
    <dialogWindow
      ref="successDialog"
      size="max"
      :detail="$t('msg.mappingDefinition.versionHistory.saveSuccess')"
      color="success"
      @select-ok="onClickSave"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from "vuex";

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
// import controlData from '../Data/asset-creation/data_control.json';
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import { DownloadFile } from "@/vue-dlb/models/DownloadFile";
// 2021.12.06 SPKA-297 svg icon
import IconSvg from "@/vue-caas/components/IconBase.vue";

export default {
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  /* 2020/11/05 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected', 'dialogCheckIn', 'versionList','reFreshList'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    versionList: Object,
    reFreshList: Function,
  },
  name: "mapping-definition-history",
  data: () => ({
    /* 
      Remove unuse code
      warningDialog: false,
      checkOutDialog: false,
      selectedDelete: null,
      successDialog: false,
      */
    fileId: "",
    lockedFlag: false,
    versionHistoryItems: {
      header: ["MPD_PRCS_NO"],
      data: [
        {
          MPD_PRCS_NO: "",
        },
      ],
    },
    currentVerItems: {
      header: ["MPD_PRCS_NO", "MPD_HST_NO"],
      data: [
        {
          MPD_PRCS_NO: "",
          MPD_HST_NO: "",
        },
      ],
    },
    lockItems: {
      header: ["MPD_PRCS_NO", "LOCK_YN"],
      data: [
        {
          MPD_PRCS_NO: "",
          LOCK_YN: "",
        },
      ],
    },
    deleteItems: {
      header: ["MPD_PRCS_NO", "MPD_HST_NO", "FILE_ID"],
      data: [
        {
          MPD_PRCS_NO: "",
          MPD_HST_NO: "",
          FILE_ID: "",
        },
      ],
    },
  }),
  created() {
    this.queryList();
  },
  computed: {
    ...mapState("mapdefinition", {
      historyList: "historyList",
    }),
  },
  methods: {
    queryList() {
      this.versionHistoryItems.data[0].MPD_PRCS_NO = this.versionList.MPD_PRCS_NO;
      Store.dispatch(
        "mapdefinition/queryHistoryList",
        this.versionHistoryItems
      ).then(() => {
        console.log("--------- Finished to process ----------");
        // console.log(JSON.stringify(this.historyList));
      });
    },
    saveVersionHistory() {
      if (this.currentVerItems.data[0].MPD_HST_NO == "") {
        let data = JSON.parse(JSON.stringify(this.historyList));
        let filtered = data.filter((item) => item.CURVER_YN === "Y");
        this.currentVerItems.data[0].MPD_HST_NO = filtered[0].HST_NO;
      }
      this.currentVerItems.data[0].MPD_PRCS_NO = this.versionList.MPD_PRCS_NO;
      // console.log("SELECTED" + JSON.stringify(this.currentVerItems));
      Store.dispatch("mapdefinition/saveCurrentVer", this.currentVerItems).then(
        () => {
          console.log("--------- Finished to process ----------");
          this.$refs.successDialog.dialog = true;
        }
      );
    },
    openCheckIn() {
      if (this.versionList.MPD_CHKIN_YN === "N" && this.lockedFlag === false) {
        this.$refs.warningDialog.dialog = true;
        return;
      }
      this.$emit("openMappingDefinitionCheckIn", {
        data: this.versionList,
        action: "checkIn",
      });
    },
    onClickSave() {
      this.reFreshList();
    },
    selectVersion(item) {
      this.currentVerItems.data[0].MPD_HST_NO = item.HST_NO;
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    /* 2020/11/05 203737 Remove unused source
      findIndexItem(item, arr, col) {
        let prop = (typeof col == 'undefined') ? 'id' : col;
        let index = arr.findIndex((row) => {
          return row[prop] === item[prop]
        })
        return (index > -1) ? index : null
      },*/
    openCheckOut(item) {
      this.fileId = item;
      this.$refs.checkOutDialog.dialog = true;
    },
    downloadFife() {
      let downloadfile = new DownloadFile();
      downloadfile.data[0].FILE_ID = this.fileId.FILE_ID;
      downloadfile.data[0].SAVE_NAME = this.versionList.MPD_FILE_NAME;
      Store.dispatch("common/DownloadFileFromServer", downloadfile).then(() => {
        console.log("--------- Finished to process ----------");
      });
    },
    onClickOkay() {
      this.lockItems.data[0].MPD_PRCS_NO = this.versionList.MPD_PRCS_NO;
      this.lockItems.data[0].LOCK_YN = "Y";
      Store.dispatch("mapdefinition/updateLock", this.lockItems).then(() => {
        console.log("--------- Finished to process ----------");
        this.lockedFlag = true;
        this.reFreshList();
        this.downloadFife();
      });
    },
    onClickCancel() {
      this.downloadFife();
    },
    deleteItem(item) {
      this.seletedDelete = item;
      this.$refs.deleteDialog.dialog = true;
    },
    onClickDelete() {
      let item = this.seletedDelete;
      this.deleteItems.data[0].MPD_PRCS_NO = this.versionList.MPD_PRCS_NO;
      this.deleteItems.data[0].MPD_HST_NO = item.HST_NO;
      this.deleteItems.data[0].FILE_ID = item.FILE_ID;
      Store.dispatch(
        "mapdefinition/deleteSelectedHistory",
        this.deleteItems
      ).then(() => {
        this.queryList();
        console.log("--------- Finished to process ----------");
      });
    },
  },
};
</script>